import { Component, OnInit, Inject } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatTabsModule,
} from "@angular/material";
import { FormBuilder, FormGroup } from "@angular/forms";
import { UserService } from "../users/user.service";
import { CitiesService } from "../cities/cities.service";
import { OrganizationsService } from "../organizations/organizations.service";
import { switchMap, debounceTime, startWith, map } from "rxjs/operators";
import { Observable } from "rxjs";
import { City } from "../cities/city";
import { Organization } from "../organizations/organization";
import {
  ActivityType,
  ActivityOperation,
  ActivitiesService,
  ActivityDetail,
} from "../activities.service";
import { PoiService } from "../poi/poi.service";

export interface User {
  loggeduser: object;
  new: boolean;
  email: string;
  password: string;
  activecities: string[];
  organization: string;
}

@Component({
  selector: "app-users",
  templateUrl: "./users.component.html",
  styleUrls: ["./users.component.css"],
})
export class UsersComponent {
  private users = [];
  private activeUsers = [];
  private disabledUsers = [];
  private user;

  constructor(
    private userService: UserService,
    public dialog: MatDialog,
    private activities: ActivitiesService,
  ) {
    let self = this;

    self.userService.currentuserAvailable.subscribe((data) => {
      if (data) {
        self.user = self.userService.currentUser;
        self.loadUsers();
      }
    });
  }

  checkIfUserCanEdit(user) {
    let self = this;
    if (self.user.type == "SuperAdmins" || self.user.type == "Admins")
      return true;
    return false;
  }

  activateUser(user) {
    let self = this;
    self.userService
      .activateUser(user)
      .then((data) => {
        self.loadUsers();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  disableUser(user) {
    let self = this;
    console.log(user);
    self.userService
      .disableUser(user)
      .then((data) => {
        self.loadUsers();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  enableUser(user) {
    let self = this;
    console.log(user);
    self.userService
      .enableUser(user)
      .then((data) => {
        self.loadUsers();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  loadUsers() {
    let self = this;
    if (self.user && self.user["type"])
      self.userService
        .listUsers(
          self.user["type"] == "SuperAdmins" ? null : self.user.organization,
        )
        .then((data) => {
          if (data && data["Users"]) {
            self.users = data["Users"];

            self.activeUsers = self.users
              .filter(
                (user) =>
                  user.Enabled === true && user.UserStatus === "CONFIRMED",
              )
              .sort((a, b) => a.Username.localeCompare(b.Username));

            self.disabledUsers = self.users
              .filter(
                (user) =>
                  user.Enabled === false || user.UserStatus !== "CONFIRMED",
              )
              .sort((a, b) => a.Username.localeCompare(b.Username));

            console.log("Total users: ", self.users.length);
            console.log("Total active users: ", self.activeUsers.length);
            console.log("Total disabled users: ", self.disabledUsers.length);
            // console.log("Disabled users: ", self.disabledUsers);
          }
        })
        .catch((err) => {
          console.log(err);
        });
  }

  userStats(user) {
    let self = this;
    const dialogRef = self.dialog.open(UserStatsDialogComponent, {
      width: "350px",
      data: { user: user },
    });
  }

  addOrEditUser(user) {
    let self = this;
    const dialogRef = self.dialog.open(UserDialogComponent, {
      width: "350px",
      data: {
        loggeduser: self.user,
        new: !user ? true : false,
        email: user ? user.Username : "",
        password: "",
        activecities: user ? user.activecities : [],
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        var organization =
          typeof result.organization === "string" ||
          result.organization instanceof String
            ? result.organization
            : result.organization.id;
        var activecities = [];
        result.activecities.forEach((city) => {
          activecities.push(city.id);
        });
        if (result.new) {
          self.userService
            .signUp(result.email, result.password, activecities, organization)
            .then((data) => {
              self.loadUsers();
              if (!result.type) {
                console.error("Type mancante, non aggiorno il ruolo");
                return;
              }
              self.userService
                .setUserType(result.email, result.type)
                .then((data) => {
                  console.log(data);
                })
                .catch((err) => {
                  console.log(err);
                });
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          self.userService
            .updateUserActiveCities(result.email, activecities, organization)
            .then((data) => {
              self.userService.getCurrentUser();

              if (!result.type) {
                console.error("Type mancante, non aggiorno il ruolo");
                return;
              }
              self.userService
                .setUserType(result.email, result.type)
                .then((data) => {
                  console.log(data);
                })
                .catch((err) => {
                  console.log(err);
                });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    });
  }
}

@Component({
  selector: "app-user-dialog-component",
  templateUrl: "./user.dialog.html",
  styleUrls: ["./users.component.css"],
})
export class UserDialogComponent implements OnInit {
  new: boolean;
  email: string;
  password: string;
  activecities: string[];
  organization: string;
  type: string;

  private user;
  private organizations = [];
  private cities = [];

  private activeCitiesList: City[] = [];
  userForm: FormGroup;
  filteredCities: Observable<City[]>;

  constructor(
    private citiesService: CitiesService,
    private userService: UserService,
    private organizationsService: OrganizationsService,
    public dialogRef: MatDialogRef<UserDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: User,
  ) {
    let self = this;

    self.new = data.new;
    self.email = data.email;
    self.password = data.password;
    self.activecities = data.activecities;
    self.user = data.loggeduser;

    if (data && data.email) {
      self.userService
        .getUser(data.email)
        .then((data) => {
          if (data && data.hasOwnProperty("UserAttributes")) {
            data["UserAttributes"].forEach((attribute) => {
              if (attribute.Name == "custom:activecities") {
                var cities = JSON.parse(attribute.Value);
                cities.forEach((city) => {
                  self.citiesService
                    .get(city)
                    .then((data) => {
                      if (data && data.data && data.data.getCities)
                        self.activeCitiesList.push(data.data.getCities);
                    })
                    .catch((err) => {
                      console.log(err);
                    });
                });
              }
              if (attribute.Name == "custom:organization") {
                self.organization = attribute.Value;
                if (
                  self.user &&
                  self.user["type"] &&
                  self.user["type"] == "SuperAdmins"
                ) {
                  self.organizationsService
                    .listOrganizations()
                    .then((data) => {
                      if (
                        data &&
                        data.data &&
                        data.data.listOrganizationss &&
                        data.data.listOrganizationss.items
                      ) {
                        var allorganizations =
                          data.data.listOrganizationss.items;
                        allorganizations.forEach((organization) => {
                          if (organization) {
                            self.organizations.push(organization);
                          }
                          if (organization.id == attribute.Value) {
                            self.organization = organization;
                            self.userForm
                              .get("organization")
                              .setValue(organization);
                          }
                        });
                      }
                    })
                    .catch((err) => {
                      console.log(err);
                    });
                } else {
                  self.organizationsService
                    .get(self.user.organization)
                    .then((organization) => {
                      self.organization = organization;
                    })
                    .catch((err) => {
                      console.log(err);
                    });
                }
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
      self.userService
        .getUserType(data.email)
        .then((group) => {
          if (
            group &&
            group["Groups"] &&
            group["Groups"].length > 0 &&
            group["Groups"][0]
          ) {
            self.userForm.get("type").setValue(group["Groups"][0].GroupName);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      if (
        self.user &&
        self.user["type"] &&
        self.user["type"] == "SuperAdmins"
      ) {
        self.organizationsService
          .listOrganizations()
          .then((data) => {
            if (
              data &&
              data.data &&
              data.data.listOrganizationss &&
              data.data.listOrganizationss.items
            ) {
              var allorganizations = data.data.listOrganizationss.items;
              allorganizations.forEach((organization) => {
                if (organization) {
                  self.organizations.push(organization);
                }
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        self.organizationsService
          .get(self.user.organization)
          .then((data) => {
            if (data && data.data && data.data.getOrganizations)
              self.organization = data.data.getOrganizations;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  }

  private onSelectedCity(event) {
    let self = this;
    if (
      event &&
      event.option &&
      event.option.value &&
      self.activeCitiesList
        .map((city) => city.id)
        .indexOf((event.option.value as City).id) < 0
    )
      self.activeCitiesList.push(event.option.value);
  }

  private removeCity(city: City) {
    let self = this;
    if (city) {
      var index = self.activeCitiesList
        .map((city) => city.id)
        .indexOf((city as City).id);
      if (index >= 0) self.activeCitiesList.splice(index, 1);
    }
  }

  ngOnInit() {
    let self = this;
    self.userForm = self.fb.group({
      email: self.email,
      password: "",
      activeCities: null,
      organization: null,
      type: null,
    });

    self.citiesService.searchJSON().subscribe((cities) => {
      self.cities = cities;
    });

    self.filteredCities = self.userForm.get("activeCities").valueChanges.pipe(
      startWith(""),
      map((value) => self.filterCities(value)),
    );
  }

  private filterCities(city: string): City[] {
    let cities = [];
    if (city && typeof city === "string")
      this.cities.forEach((element) => {
        if (element.name.toLowerCase().indexOf(city.toLowerCase()) !== -1) {
          cities.push(element);
        }
      });
    return cities;
  }

  onNoClick(): void {
    let self = this;
    self.dialogRef.close();
  }

  save() {
    let self = this;
    self.dialogRef.close({
      new: self.new,
      email: self.userForm.get("email").value,
      password: self.userForm.get("password").value,
      activecities: self.activeCitiesList,
      organization:
        self.user.type == "SuperAdmins"
          ? self.userForm.get("organization").value
          : self.user.organization,
      type: self.userForm.get("type").value,
    });
  }

  close() {
    let self = this;
    self.dialogRef.close();
  }

  displayFn(city: City) {
    if (city) {
      return city.name;
    }
  }

  displayOrg(organization: Organization) {
    if (organization) {
      return organization.name;
    }
  }
}

@Component({
  selector: "app-userstats-dialog-component",
  templateUrl: "./userStats.dialog.html",
  styleUrls: ["./users.component.css"],
})
export class UserStatsDialogComponent implements OnInit {
  private user;
  private dateStart;
  private dateEnd;
  private loading: boolean = false;

  private cStats = [];
  private pStats = [];

  constructor(
    private userService: UserService,
    private organizationsService: OrganizationsService,
    private citiesService: CitiesService,
    private poiService: PoiService,
    public dialogRef: MatDialogRef<UserStatsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    let self = this;
    self.user = data.user;
  }

  ngOnInit() {}

  userStats() {
    let self = this;

    let user = self.user.Username;
    let organization = self.user.Attributes[0].Value;
    let start = new Date(self.dateStart).toISOString();
    let end = new Date(self.dateEnd).toISOString();

    if (user && organization && start && end) {
      self.loading = true;
      self.userService
        .statistics(user, organization, start, end)
        .then((data) => {
          let stats = JSON.parse(data.data.userStatistics);
          console.log(stats);
          if (stats.c) {
            Object.keys(stats.c).forEach((city) => {
              self.citiesService
                .get(city)
                .then((citydata) => {
                  if (
                    citydata &&
                    citydata.data &&
                    citydata.data.getCities &&
                    citydata.data.getCities.name
                  ) {
                    self.cStats[citydata.data.getCities.name] = stats.c[city];
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            });
          }
          if (stats.t) {
            Object.keys(stats.t).forEach((poitype) => {
              self.poiService
                .getType(poitype)
                .then((poiType) => {
                  if (
                    poiType &&
                    poiType.data &&
                    poiType.data.getPoiType &&
                    poiType.data.getPoiType.name
                  ) {
                    self.pStats[poiType.data.getPoiType.name] =
                      stats.t[poitype];
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            });
          }
          self.loading = false;
        });
    }
  }

  onNoClick(): void {
    let self = this;
    self.dialogRef.close();
  }

  close() {
    let self = this;
    self.dialogRef.close();
  }
}
